import { useEffect, useState } from 'react';

import { WebAPI } from '../../MedicareProAPI/API/WebAPI';
import BarChart from '../Components/Charts/BarChart';
import Loader from '../Components/Loader';

export default function AgentAnalyticsProductionPanel(props) {
  const [ytdRevenue, setYTDRevenue] = useState(null);
  const [ytdRevenueShow, setYTDRevenueShow] = useState(null);
  const [ytdProduction, setYTDProduction] = useState(null);

  const [sourceLabels, setSourceLabels] = useState(null);
  const [sourceTotals, setSourceTotals] = useState(null);

  const [stateLabels, setStateLabels] = useState(null);
  const [stateTotals, setStateTotals] = useState(null);

  const [policiesLabels, setPoliciesLabels] = useState(null);
  const [policiesTotals, setPoliciesTotals] = useState(null);

  const [policiesByCompanyLabels, setPoliciesByCompanyLabels] = useState(null);
  const [policiesByCompanyTotals, setPoliciesByCompanyTotals] = useState(null);

  const [aepProductionLabels, setAEPProductionLabels] = useState(null);
  const [aepProductionTotals, setAEPProductionTotals] = useState(null);

  const [productionEffectiveLabels, setProductionEffectiveLabels] = useState(null);
  const [productionEffectiveTotals, setProductionEffectiveTotals] = useState(null);
  const [productionSelected, setProductionSelected] = useState('effective');

  const [productionAppDateLabels, setProductionAppDateLabels] = useState(null);
  const [productionAppDateTotals, setProductionAppDateTotals] = useState(null);

  const [salesByMonthYearSelected, setSalesByMonthYearSelected] = useState(null);
  const [productionByMonthLabels, setProductionByMonthLabels] = useState(null);
  const [productionByMonthTotals, setProductionByMonthTotals] = useState(null);

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  const webAPI = new WebAPI();
  webAPI.setAccessToken(props.userAccessToken);

  const getProductionByYear = (year) => {
    setSalesByMonthYearSelected(year);
    webAPI.getUserProductionByYear(props.userId, year, productionSelected).then((response) => {
      setProductionByMonthLabels(Array.from(response.data, (aepYear) => aepYear.month));
      setProductionByMonthTotals(
        Array.from(response.data, (aepYear) => (aepYear.total ? parseInt(aepYear.total) : 0))
      );
    });
  };

  const handleYearlyProductionReset = (userId, type) => {
    setSalesByMonthYearSelected(false);
    setProductionByMonthLabels(null);
    setProductionByMonthTotals(null);
  };
  // Get User Plan types on first load

  useEffect(() => {
    let total = 0;
    let currentData = new Date();
    let firstDayOfYearString = currentData.getFullYear() + '-01-01';
    let currentDateString =
      currentData.getFullYear() + '-' + (currentData.getMonth() + 1) + '-' + currentData.getDate();

    webAPI
      .getIndsGrouped('ind_source', props.userId, { indStatus: 'Active Client' })
      .then((sourceResponse) => {
        let sourceData = sourceResponse.data.sort((a, b) => b.total - a.total);
        setSourceLabels(Array.from(sourceData, (source) => source.field));
        setSourceTotals(
          Array.from(sourceData, (source) => (source.total ? parseInt(source.total) : 0))
        );
      });

    webAPI
      .getIndsGrouped('byState', props.userId, { indStatus: 'Active Client' })
      .then((statesResponse) => {
        let stateData = statesResponse.data.sort((a, b) => b.total - a.total);
        setStateLabels(Array.from(stateData, (state) => state.field));
        setStateTotals(Array.from(stateData, (state) => (state.total ? parseInt(state.total) : 0)));
      });

    webAPI.getUserPoliciesGrouped('policy_type', props.userId).then((policyTypeResponse) => {
      let policyTypeData = policyTypeResponse.data.sort((a, b) => b.total - a.total);
      setPoliciesLabels(Array.from(policyTypeData, (policyType) => policyType.field));
      setPoliciesTotals(
        Array.from(policyTypeData, (policyType) =>
          policyType.total ? parseInt(policyType.total) : 0
        )
      );
    });

    webAPI
      .getUserPoliciesGrouped('policy_company', props.userId)
      .then((policyByCompanyResponse) => {
        let policyByCompanyData = policyByCompanyResponse.data.sort((a, b) => b.total - a.total);
        setPoliciesByCompanyLabels(
          Array.from(policyByCompanyData, (policyCompany) => policyCompany.field)
        );
        setPoliciesByCompanyTotals(
          Array.from(policyByCompanyData, (policyCompany) =>
            policyCompany.total ? parseInt(policyCompany.total) : 0
          )
        );
      });

    webAPI.getUserAEPProduction(props.userId).then((productonResponse) => {
      setAEPProductionLabels(Array.from(productonResponse.data, (aepYear) => aepYear.year - 1));
      setAEPProductionTotals(
        Array.from(productonResponse.data, (aepYear) =>
          aepYear.total ? parseInt(aepYear.total) : 0
        )
      );
    });

    webAPI.getUserProduction(props.userId, 'app_date').then((productonResponse) => {
      setProductionAppDateLabels(Array.from(productonResponse.data, (aepYear) => aepYear.year));
      setProductionAppDateTotals(
        Array.from(productonResponse.data, (aepYear) =>
          aepYear.total ? parseInt(aepYear.total) : 0
        )
      );
    });

    webAPI.getUserProduction(props.userId, 'effective').then((productonResponse) => {
      if (productonResponse.data && productonResponse.data.length > 0) {
        setYTDProduction(productonResponse.data[productonResponse.data.length - 1].total);
      } else {
        setYTDProduction(0);
      }

      setProductionEffectiveLabels(Array.from(productonResponse.data, (aepYear) => aepYear.year));
      setProductionEffectiveTotals(
        Array.from(productonResponse.data, (aepYear) =>
          aepYear.total ? parseInt(aepYear.total) : 0
        )
      );
    });
  }, []);

  return (
    <div className="row">
      {/* Current Renewals & 

         <div className="col-sm-12 col-md-4 pb-2 px-2 sm-resp">
            <div className=" col-sm-12 col-md-12 px-0 mb-2">
               <div className="card card-tall text-blacktext mb-0">
                  <div className="card-header font-weight-bold py-2 ">YTD Revenue</div>
                  <div className="card-body pt-4" sx={{ overflowY: 'hidden !important' }}>
                     <div className="row" sx={{ marginTop: '-10px' }}>
                        <div className="col-3">
                           <i className="fal fa-badge-dollar fa-3x text-primary align-self-top"></i>
                        </div>
                        <div className="col-9 money">
                           <h2 className="font-weight-bold  text-right align-middle mt-1" id="successCount">{ytdRevenue !== null ? formatter.format(ytdRevenue) : <LoaderWheel />}</h2>
                        </div>
                     </div>
                  </div>
               </div>
            </div>

            <div className=" col-sm-12 col-md-12 px-0">
               <div className="card card-tall text-blacktext mb-0">
                  <div className="card-header font-weight-bold py-2 ">YTD Production</div>
                  <div className="card-body pt-4" sx={{ overflowY: 'hidden !important' }}>
                     <div className="row" sx={{ marginTop: '-10px' }}>
                        <div className="col-3">
                           <i className="fal fa-badge-dollar fa-3x text-success align-self-top"></i>
                        </div>
                        <div className="col-9 money">
                           <h2 className="font-weight-bold  text-right align-middle mt-1" id="successCount">{(ytdProduction !== null) ? <>{ytdProduction.toLocaleString()} <small>apps</small></> : <LoaderWheel />}</h2>
                        </div>
                     </div>
                  </div>
               </div>
            </div>

         </div>
          */}

      <div className="col-12 pb-2 px-2 sm-resp">
        <div className="card card-tall">
          <div className="card-header font-weight-bold py-2">
            {salesByMonthYearSelected ? salesByMonthYearSelected : 'Yearly'} Production{' '}
            <i className="font-weight-light">(apps written)</i>
          </div>
          <div className="px-3">
            {!salesByMonthYearSelected && (
              <>
                <button
                  type="button"
                  className={[
                    'ml-2',
                    'badge',
                    'border',
                    'cp',
                    'border-secondary',
                    productionSelected === 'effective' ? 'badge-success' : 'badge-secondary',
                  ].join(' ')}
                  onClick={(e) => {
                    setProductionSelected('effective');
                  }}
                >
                  Effective Date
                </button>
                <button
                  type="button"
                  className={[
                    'ml-2',
                    'badge',
                    'border',
                    'cp',
                    'border-secondary',
                    productionSelected === 'app_date' ? 'badge-success' : 'badge-secondary',
                  ].join(' ')}
                  onClick={(e) => {
                    setProductionSelected('app_date');
                  }}
                >
                  Application Date
                </button>
              </>
            )}
            {salesByMonthYearSelected && (
              <button
                type="button"
                className={[
                  'ml-2',
                  'badge',
                  'border',
                  'cp',
                  'border-secondary',
                  'badge-secondary',
                ].join(' ')}
                onClick={() => handleYearlyProductionReset('effective')}
              >
                Year over year
              </button>
            )}
          </div>

          <div className="card-body pt-1 pb-0 pl-0 pr-0">
            {!productionByMonthLabels &&
              (productionEffectiveLabels &&
              productionEffectiveTotals &&
              productionAppDateLabels &&
              productionAppDateTotals ? (
                productionEffectiveTotals.length > 0 && productionAppDateTotals.length > 0 ? (
                  <BarChart
                    className="chart-labels-bold"
                    data={{
                      labels:
                        productionSelected === 'effective'
                          ? productionEffectiveLabels
                          : productionAppDateLabels,
                      series:
                        productionSelected === 'effective'
                          ? productionEffectiveTotals
                          : productionAppDateTotals,
                    }}
                    options={{
                      height: '400px',
                      distributeSeries: true,
                      axisY: {
                        showLabel: false,
                      },
                    }}
                    onBarClick={getProductionByYear}
                  />
                ) : (
                  <div data-alert className="alert alert-info mx-3 mb-0">
                    Not enough data to show this chart.
                  </div>
                )
              ) : (
                <Loader size="large" />
              ))}
            {productionByMonthLabels && (
              <BarChart
                className="chart-labels-bold"
                data={{
                  labels: productionByMonthLabels,
                  series: productionByMonthTotals,
                }}
                options={{
                  height: '400px',
                  distributeSeries: true,
                  axisY: {
                    showLabel: false,
                  },
                }}
              />
            )}
          </div>
        </div>
      </div>

      <div className="col-sm-12 col-md-8 pb-2 px-2 sm-resp">
        <div className="card card-tall">
          <div className="card-header font-weight-bold py-2">
            AEP Production <i className="font-weight-light">(MAPD/PDP apps written)</i>
          </div>
          <div className="card-body pt-1 pb-0 pl-0 pr-0">
            {aepProductionLabels && aepProductionTotals ? (
              aepProductionTotals.length > 0 ? (
                <BarChart
                  className="chart-labels-bold"
                  data={{
                    labels: aepProductionLabels,
                    series: aepProductionTotals,
                  }}
                  options={{
                    height: '400px',
                    distributeSeries: true,
                    axisY: {
                      showLabel: false,
                    },
                  }}
                />
              ) : (
                <div data-alert className="alert alert-info mx-3 mb-0">
                  Not enough data to show this chart.
                </div>
              )
            ) : (
              <Loader size="large" />
            )}
          </div>
        </div>
      </div>

      <div className="col-sm-12 col-md-4 pb-2 px-2 sm-resp">
        <div className="card card-tall">
          <div className="card-header font-weight-bold py-2">Policy Count By Type</div>
          <div className="card-body pt-1 pb-0 pl-0 pr-0">
            {policiesLabels && policiesTotals ? (
              policiesTotals.length > 0 ? (
                <BarChart
                  className="chart-labels-bold"
                  data={{
                    labels: policiesLabels,
                    series: policiesTotals,
                  }}
                  options={{
                    height: '400px',
                    distributeSeries: true,
                    axisY: {
                      showLabel: false,
                    },
                  }}
                />
              ) : (
                <div data-alert className="alert alert-info mx-3 mb-0">
                  Not enough data to show this chart.
                </div>
              )
            ) : (
              <Loader size="large" />
            )}
          </div>
        </div>
      </div>

      <div className="col-sm-12 col-md-12 pb-2 px-2 sm-resp">
        <div className="card card-tall">
          <div className="card-header font-weight-bold py-2">
            Policies by Company <i style={{ fontWeight: 'normal' }}>(Active/Pending)</i>
          </div>
          <div className="card-body pt-1 pb-0 pl-0 pr-0">
            {policiesByCompanyLabels && policiesByCompanyTotals ? (
              policiesByCompanyTotals.length ? (
                <BarChart
                  className="chart-labels-bold"
                  data={{
                    labels: policiesByCompanyLabels,
                    series: policiesByCompanyTotals,
                  }}
                  options={{
                    height: '400px',
                    distributeSeries: true,
                    axisY: {
                      showLabel: false,
                    },
                  }}
                />
              ) : (
                <div data-alert className="alert alert-info mx-3 mb-0">
                  Not enough data to show this chart.
                </div>
              )
            ) : (
              <Loader size="large" />
            )}
          </div>
        </div>
      </div>

      <div className="col-sm-12 col-md-12 pb-2 px-2 sm-resp">
        <div className="card card-tall">
          <div className="card-header font-weight-bold py-2">Clients by Source</div>
          <div className="card-body pt-1 pb-0 pl-0 pr-0">
            {sourceLabels && sourceTotals ? (
              sourceTotals.length ? (
                <BarChart
                  className="chart-labels-bold"
                  data={{
                    labels: sourceLabels,
                    series: sourceTotals,
                  }}
                  options={{
                    height: '400px',
                    distributeSeries: true,
                    axisY: {
                      showLabel: false,
                    },
                  }}
                />
              ) : (
                <div data-alert className="alert alert-info mx-3 mb-0">
                  Not enough data to show this chart.
                </div>
              )
            ) : (
              <Loader size="large" />
            )}
          </div>
        </div>
      </div>

      <div className="col-sm-12 col-md-12 pb-2 px-2 sm-resp">
        <div className="card card-tall">
          <div className="card-header font-weight-bold py-2">Clients by State</div>
          <div className="card-body pt-1 pb-0 pl-0 pr-0">
            {stateLabels && stateTotals ? (
              stateTotals.length ? (
                <BarChart
                  className="chart-labels-bold"
                  data={{
                    labels: stateLabels,
                    series: stateTotals,
                  }}
                  options={{
                    height: '400px',
                    distributeSeries: true,
                    axisY: {
                      showLabel: false,
                    },
                  }}
                />
              ) : (
                <div data-alert className="alert alert-info mx-3 mb-0">
                  Not enough data to show this chart.
                </div>
              )
            ) : (
              <Loader size="large" />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
